import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import WorkTypeList from './Components/WorkType/WorkTypeList';
import WorkshopList from './Components/Workshop/WorkshopList';
import WorkshopForm from './Components/Workshop/WorkshopForm';
import Login from "./Components/Login/Login";
import WorkshopDashboard from "./Components/Dashboard/Dashboard";
import EmployeeList from "./Components/Employee/EmployeeList";
import AddEmployee from "./Components/Employee/AddEmployee";
import MainLayout from "./Components/Common/MainLayout";
import CustomerPage from "./Components/Customers/Customers";
import VisitHistory from "./Components/Visit/VisitHistory";
import EmployeeProfile from "./Components/Employee/EmployeeProfile";
import InventoryList from "./Components/Inventory/InventoryList";
import BillList from "./Components/Billing/BillList";
import Registeration from "./Components/Login/Registration";
import {AuthContextProvider} from "./Components/Common/AuthContext";
import JobcardList2 from "./Components/Jobcard/JobcardList2";
import ReportDashboard from "./Components/Dashboard/Report/ReportDashboard";
import LoanList from "./Components/Loan/LoanList";
import LoanDetails from "./Components/Loan/LoanDetails";
import LoanCalculator from "./Components/Loan/LoanCalculator";
import PendingEMIList from "./Components/Loan/PendingEMIList";
import LoanDashboard from "./Components/Loan/LoanDashboard";
import {WorkshopProvider} from "./Components/Common/WorkshopContext";
import AssetManagementPage from "./Components/Asset/AssetManagementPage";
import CustomerProfilePage from "./Components/Customers/CustomerProfile";
import LoyaltyDashboard from "./Components/LoyaltyCard/LoyaltyCardDashboard";
import ErrorBoundary from "./Components/Common/ErrorBoundary";
import AiSearchDashboard from "./Components/AI/AiSearchDashboard";
import FinanceReports from "./Components/Loan/FinanceReports";
import EconomicUnitReport from "./Components/Loan/EconomicUnitReport";
import BranchList from "./Components/Loan/BranchList";
import OperationalExpensesList from "./Components/OperationalExpense/OperationalExpensesList";
import DataToolsPage from "./Components/DataTools/DataToolsPage";


function App() {
    return (
        <div className="font-inter">
            <ErrorBoundary>
                <AuthContextProvider>
                    <WorkshopProvider>
                        <BrowserRouter>
                            <MainLayout>
                                <Routes>
                                    {/*<Route path="/" element={<Login/>}/>*/}
                                    <Route path="/login" element={<Login/>}/>
                                    <Route path="/registration" element={<Registeration/>}/>
                                    <Route path="/workshops/dashboard/:workshopId" element={<WorkshopDashboard/>}/>
                                    <Route path="/ai-chat" element={<AiSearchDashboard/>}/>
                                    <Route path="/workshops" element={<WorkshopList/>}/>
                                    <Route path="/customers" element={<CustomerPage/>}/>
                                    {/*<Route path="/workshops/dashboard/:workshopId" element={<WorkshopDashboard />} />*/}
                                    <Route path="/work-types" element={<WorkTypeList/>}/>
                                    {/*<Route path="/worktypes/add" exact component={WorkTypeForm}/>*/}
                                    {/*<Route path="/worktypes/edit/:id" exact component={WorkTypeForm}/>*/}
                                    <Route path="/workshops/add" exact component={WorkshopForm}/>
                                    <Route path="/workshops/edit/:id" exact component={WorkshopForm}/>
                                    <Route path="/employees" element={<EmployeeList/>}/>
                                    {/*<Route path="/employees-2" element={<EmployeeList2/>}/>*/}
                                    <Route path="/add-employee" element={<AddEmployee/>}/>
                                    <Route path="/employees/:employeeId" element={<EmployeeProfile/>}></Route>
                                    <Route path="/workshops/:id/customers" element={<CustomerPage/>}/>
                                    <Route path="/job-cards" element={<JobcardList2/>}/>
                                    <Route path="/workshop/inventory" element={<InventoryList/>}/>
                                    <Route path="/workshop/reports" element={<ReportDashboard/>}/>
                                    <Route
                                        path="/customers/:customerId/workshops/:workshopId/visit-history"
                                        element={<VisitHistory/>}
                                    />
                                    <Route
                                        path="/customers/:customerId/workshops/:workshopId/profile"
                                        element={<CustomerProfilePage/>}
                                    />

                                    <Route path="/workshop/assets" element={<AssetManagementPage/>}/>
                                    <Route path="/workshop/bills" element={<BillList/>}/>
                                    <Route path="/workshop/loans" element={<LoanList/>}/>
                                    <Route path="/loans/:loanId" element={<LoanDetails/>}/>
                                    <Route path="/loans/calculator" element={<LoanCalculator/>}/>
                                    <Route path="/loans/emis/pending" element={<PendingEMIList/>}/>
                                    <Route path="/loans/dashboard" element={<LoanDashboard/>}/>
                                    <Route path="/loans/finance-reports" element={<FinanceReports/>}/>
                                    <Route path="/loans/economic-unit-report" element={<EconomicUnitReport/>}/>

                                    <Route path="/loyalty-card/dashboard" element={<LoyaltyDashboard/>}/>
                                    <Route path="/branches" element={<BranchList/>}/>
                                    <Route path="/workshop/operational-expenses" element={<OperationalExpensesList/>}/>
                                    <Route path="/data-tools" element={<DataToolsPage/>}/>
                                </Routes>
                            </MainLayout>
                        </BrowserRouter>
                    </WorkshopProvider>

                </AuthContextProvider> <AuthContextProvider>

            </AuthContextProvider>
            </ErrorBoundary>
        </div>

    );
}

export default App;
